import { RightAction } from "../../types";


export function isRightAction(v: unknown): v is RightAction {
    return (
        typeof v === 'object' &&
        v !== null &&
        typeof (v as any).id === 'string' &&
        typeof (v as any).label === 'string'
    );
}

/**
 * Normaliza a array, filtra a RightAction y limita a 'max' elementos.
 * Loguea si recorta.
 */
export function sanitizeRightActions(val: unknown, max = 2, label = 'mega-menu custom-options'): RightAction[] {
    const arr = Array.isArray(val) ? (val as unknown[]) : [];
    const onlyValid = arr.filter(isRightAction) as RightAction[];

    if (onlyValid.length > max) {
        console.error(`[${label}] admite máximo ${max} elementos; se usarán los primeros ${max}.`);
        return onlyValid.slice(0, max);
    }
    return onlyValid;
}
